// extracted by mini-css-extract-plugin
module.exports = {"container":"GlobalDesktopHeaderAccountMenu_container__3GEpR","dropDown":"GlobalDesktopHeaderAccountMenu_dropDown__5Xd3D","sending":"GlobalDesktopHeaderAccountMenu_sending__NDHEB"};